/**
 * App Component
 * @Dependencies
 *  https://materializecss.com/
 *    http://fullstackhybrid.com/using-materializecss-with-reactjs/
 */

import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import withAutorization from './components/auth/withAuthorization';
import PageWizard from './components/pages/PageWizard';
import PageConfigurationSubmit from './components/pages/configurationSubmit/PageConfigurationSubmit';

import { getConfUrlBasePathName } from './conf/conf';

import gaSetup from './helpers/google-analytics-helper';
import { setup as mobileDetectorSetup} from './helpers/mobile-detector';
import { urlContextInit } from './helpers/browser-navigation-helper';

import 'materialize-css/dist/css/materialize.min.css';
import './themes/default.css';
import './App.css';
/*import './fonts/novecentosanswide_book/stylesheet.css';*/
import './fonts/novecentosanswide_medium/stylesheet.css';
import './libs/ak-toastr/ak-toastr.min.css';

// Setup google analytics
gaSetup();

// Set up mobile detector
mobileDetectorSetup();

// Init url context
urlContextInit();

// Export App
class App extends Component {

    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //console.log('this.props ', this.props);
    }

    render() {
        return (
            <Router basename={ getConfUrlBasePathName() }>
            <Switch>
                <Route path="/" exact>
                    <Redirect to="/wizard/" />
                </Route>
                <Route path="/wizard/">
                    <PageWizard />
                </Route>
                <Route path="/invia-configurazione/">
                    <PageConfigurationSubmit />
                </Route>
            </Switch>
            </Router>
        );
    }
}

export default withAutorization(App);
